export const translationCache = new Map<string, Record<string, unknown>>();
export const translationInFlight = new Map<string, Promise<Record<string, unknown>>>();

const translationStoreListeners = new Set<() => void>();
let translationStoreVersion = 0;

export function getCacheKey(lang: string, component: string) {
    return `${lang}-${component}`;
}

export function emitTranslationStoreChange() {
    translationStoreVersion += 1;
    for (const listener of translationStoreListeners) {
        listener();
    }
}

export function subscribeToTranslationStore(listener: () => void) {
    translationStoreListeners.add(listener);
    return () => {
        translationStoreListeners.delete(listener);
    };
}

export function getTranslationStoreSnapshot() {
    return translationStoreVersion;
}
